<form *ngIf="form" [formGroup]=form>
    <h4 class="bk-modal__section-title">
        {{'Calculate Micro Sprinkler Application Rate' | translate }}
    </h4>
    
    <div class="bk-form-group">
        <div class="bk-modal__right-collapse">
            <label class="bk-modal__label">
                {{'In Row Tree Spacing' | translate}}
            </label>
            <input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
                type="number"
                step="1"
                required
                name="InRowTreeSpacing"
                formControlName="InRowTreeSpacing"/>
            <div class="bk-modal__field-unit">
                {{'ft' | translate}}
            </div>
        </div>
        <div class="bk-modal__right-collapse">
            <label class="bk-modal__label">
                {{'Between Row Tree Spacing' | translate}}
            </label>
            <input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
                type="number"
                step="1"
                required
                name="BetweenRowTreeSpacing"
                formControlName="BetweenRowTreeSpacing"/>
            <div class="bk-modal__field-unit">
                {{'ft' | translate}}
            </div>
        </div>
        <div class="bk-modal__right-collapse">
            <label class="bk-modal__label">
                {{'Micro Sprinklers per Tree' | translate}}
            </label>
            <input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
                type="number"
                step="1"
                required
                name="MicroSprinklersPerTree"
                formControlName="MicroSprinklersPerTree"/>
        </div>
    </div>

    <mat-radio-group aria-label=""
        name="UseFlowRate"
        formControlName="UseFlowRate">

        <mat-radio-button [value]="false"
            name="useFlowRate">
            {{'Choose microsprinkler from a list' | translate}}
        </mat-radio-button>

        <mat-radio-button [value]="true"
            class="mat-radio-button--left-margin"
            name="useFlowRate">
            {{'Enter flow rate manually' | translate}}
        </mat-radio-button>
        
    </mat-radio-group>
    <ng-container *ngIf="f.UseFlowRate.value === true">
        <label class="bk-modal__label">
            {{'Flow Rate' | translate}}
        </label>
        <input class="bk-modal__field--with-unit bk-input--x-short bk-modal__field"
            type="number"
            step="1"
            required
            name="FlowRate"
            formControlName="FlowRate"/>
        <div class="bk-modal__field-unit">
            {{'gallons/hour' | translate}}
        </div>
    </ng-container>
    <ng-container *ngIf="f.UseFlowRate.value === false">
        <div class="bk-col-6">
            <label class="bk-modal__label">
                {{'Manufacturer' | translate }}
            </label>

            <select class="bk-input--full bk-select--medium bk-modal__field"
                formControlName="ManufacturerId"
                required
                name="Manufacturer">
                <option value="" selected>
                    {{'Select One' | translate }}
                </option>
                <option *ngFor="let manufacturer of manufacturers"
                    [ngValue]="manufacturer.Id">
                    {{manufacturer.Name}}
                </option>
            </select>
        </div>

        <div class="bk-col-6">
            <label class="bk-modal__label">
                {{'Series' | translate }} / {{ 'Model' | translate }}
            </label>

            <select class="bk-input--full bk-select--medium bk-modal__field"
                formControlName="SeriesId"
                required
                name="Series">

                <option value="" selected>
                    {{'Select One' | translate }}
                </option>
                <option *ngFor="let series of seriesList"
                    [ngValue]="series.Id">
                    {{series.Name}}
                </option>
            </select>
        </div>
        
        <div class="bk-col-6">
            <label class="bk-modal__label">
                {{'Color' | translate }} / {{'Nozzle' | translate}}
            </label>

            <select class="bk-input--full bk-select--medium bk-modal__field"
                formControlName="ColorId"
                required
                name="Color">

                <option value="" selected>
                    {{'Select One' | translate }}
                </option>
                <option *ngFor="let color of colors"
                    [ngValue]="color.Id">
                    {{color.Name}}
                </option>
            </select> 
        </div>
        
        <div class="bk-col-6">
            <label class="bk-modal__label">
                {{'Pressure' | translate }} (psi)
            </label>

            <select class="bk-input--full bk-select--medium bk-modal__field"
                formControlName="PressureName"
                required
                name="PressureName">

                <option value="" selected>
                    {{'Select One' | translate }}
                </option>

                <option *ngFor="let pressure of pressures"
                    [ngValue]="pressure.Name">
                    {{pressure.Name}}
                </option>
            </select>
        </div>
    </ng-container>

    <div class="bk-modal__section-buttons">
        <button *ngIf="f.UseFlowRate.value === false"
            class="bk-button bk-button--medium bk-button--text-only"
            (click)="reset()">
            {{ 'Reset' | translate }}
        </button>
        <button class="bk-button bk-button--medium bk-button--text-only"
            (click)="cancel($event)">
            {{'Cancel' | translate }}
        </button>
        <button class="bk-button bk-button--medium"
            [disabled]='form.invalid'
            (click)="calculate($event)">
            {{'Calculate' | translate }}
        </button>
    </div>
</form>